import Navbar from "./navBar";
import SectionOne from "./AboutComponents/sectionOne";
import "../css/TeeStyles.css";
import SectionTwo from "./AboutComponents/sectionTwo";
import SectionSix from "./sectionSix";
import { ReactElement } from "react";

const About: React.FC = (): ReactElement => {
  return (
    <>
      <Navbar />
      <main>
        <SectionOne content="About Us" />
        <SectionTwo />
        <SectionSix />
      </main>
    </>
  );
};
export default About;
